module.exports = __webpack_public_path__ + "media/apps/hero-illustration-bg-23bf848e.jpg";